import { Component, OnInit } from '@angular/core';
import { AuthStateService } from '../../services/auth-state.service';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  menuMode = 'static';
  colorScheme = 'light';
  menuTheme = 'layout-sidebar-darkgray';
  overlayMenuActive: boolean;
  staticMenuDesktopInactive: boolean;
  staticMenuMobileActive: boolean;
  menuClick: boolean;
  search = false;
  searchClick = false;
  userMenuClick: boolean;
  topbarUserMenuActive: boolean;
  notificationMenuClick: boolean;
  topbarNotificationMenuActive: boolean;
  rightMenuClick: boolean;
  rightMenuActive: boolean;
  configActive: boolean;
  configClick: boolean;
  resetMenu: boolean;
  menuHoverActive = false;
  inputStyle = 'outlined';
  ripple: boolean;

  constructor(
    private menuService: MenuService,
    public auth: AuthStateService
  ) { }

  ngOnInit(): void {
  }

  public onLayoutClick(): void {
    if (!this.searchClick) {
        this.search = false;
    }

    if (!this.userMenuClick) {
        this.topbarUserMenuActive = false;
    }

    if (!this.notificationMenuClick) {
        this.topbarNotificationMenuActive = false;
    }

    if (!this.rightMenuClick) {
        this.rightMenuActive = false;
    }

    if (!this.menuClick) {
        if (this.isSlim()) {
            this.menuService.reset();
        }

        if (this.overlayMenuActive || this.staticMenuMobileActive) {
            this.hideOverlayMenu();
        }

        this.menuHoverActive = false;
        this.unblockBodyScroll();
    }

    if (this.configActive && !this.configClick) {
        this.configActive = false;
    }

    this.searchClick = false;
    this.configClick = false;
    this.userMenuClick = false;
    this.rightMenuClick = false;
    this.notificationMenuClick = false;
    this.menuClick = false;
}

public onMenuButtonClick(event: any): void {
    this.menuClick = true;
    this.topbarUserMenuActive = false;
    this.topbarNotificationMenuActive = false;
    this.rightMenuActive = false;

    if (this.isOverlay()) {
        this.overlayMenuActive = !this.overlayMenuActive;
    }

    if (this.isDesktop()) {
        this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
    } else {
        this.staticMenuMobileActive = !this.staticMenuMobileActive;
        if (this.staticMenuMobileActive) {
            this.blockBodyScroll();
        } else {
            this.unblockBodyScroll();
        }
    }

    event.preventDefault();
  }

  public onSearchClick(event: any): void {
      this.search = !this.search;
      this.searchClick = !this.searchClick;
  }

  public onMenuClick(): void {
      this.menuClick = true;
      this.resetMenu = false;
  }

  public onTopbarUserMenuButtonClick(event): void {
      this.userMenuClick = true;
      this.topbarUserMenuActive = !this.topbarUserMenuActive;

      this.hideOverlayMenu();

      event.preventDefault();
  }

  public onTopbarNotificationMenuButtonClick(event: any): void {
      this.notificationMenuClick = true;
      this.topbarNotificationMenuActive = !this.topbarNotificationMenuActive;

      this.hideOverlayMenu();

      event.preventDefault();
  }

  public onRightMenuClick(event: any): void {
      this.rightMenuClick = true;
      this.rightMenuActive = !this.rightMenuActive;

      this.hideOverlayMenu();

      event.preventDefault();
  }

  public onRippleChange(event: any): void {
      this.ripple = event.checked;
  }

  public onConfigClick(): void {
      this.configClick = true;
  }

  public isSlim(): boolean {
      return this.menuMode === 'slim';
  }

  public isOverlay(): boolean {
      return this.menuMode === 'overlay';
  }

  public isDesktop(): boolean {
      return window.innerWidth > 991;
  }

  public isMobile(): boolean {
      return window.innerWidth <= 991;
  }

  public hideOverlayMenu(): void {
      this.overlayMenuActive = false;
      this.staticMenuMobileActive = false;
  }

  public blockBodyScroll(): void {
      if (document.body.classList) {
          document.body.classList.add('blocked-scroll');
      } else {
          document.body.className += ' blocked-scroll';
      }
  }

  public unblockBodyScroll(): void {
      if (document.body.classList) {
          document.body.classList.remove('blocked-scroll');
      } else {
          document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
              'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
      }
  }
}
